
import StakeholderListRow from "@/components/StakeholderList/StakeholderListRow.vue";
import Header from "@/components/Header.vue";
import {
  getNormalizedItemsByUniqueItemProp,
  getAlternativeById,
  c_alternativesIds,
  state,
  getCriterionName,
} from "@/store";
import { defineComponent, ref } from "vue";

export default defineComponent({
  props: {
    id: Number,
  },

  setup(props) {
    const height = ref(null);

    return {
      state,
      height,
      c_alternativesIds,

      getCriterionName,
      setHeight: () => {
        const tableFilters = document.querySelector("[table-filters]");

        if (tableFilters) {
          const tableFiltersRect = tableFilters.getBoundingClientRect();
          height.value = window.innerHeight - tableFiltersRect.bottom - 24;
        }
      },
      getNormalizedItemsByUniqueItemProp,
      getAlternativeById,
    };
  },

  // data: () => ({
  //   state,
  //   height: ""
  // }),
  components: {
    Header,
    StakeholderListRow,
  },
  // computed: {
  //   alternativesIds
  // },
  mounted() {
    this.$nextTick(this.setHeight);
  },
  updated() {
    this.$nextTick(this.setHeight);
  },
  created() {
    window.addEventListener("resize", this.setHeight);
  },
  destroyed() {
    window.removeEventListener("resize", this.setHeight);
  },
  // methods: {

  // },
  // props: ["id"]
});
